import type { FrontendWidget } from '../types';
import { NewsletterSubscriptionComponent } from './NewsletterSubscriptionComponent';
import type {
  NewsletterSubscriptionConfig,
  NewsletterSubscriptionResolved,
} from './types';

export const newsletterSubscriptionWidget: FrontendWidget<
  NewsletterSubscriptionConfig,
  NewsletterSubscriptionResolved
> = {
  componentType: 'widgets.newsletter-subscription',
  displayName: 'Newsletter Subscription',
  // Inline widget: no backend resolver, nothing to look up.
  ComponentA: NewsletterSubscriptionComponent,
  resolveSync: (config) => config,
};
